module.exports = __webpack_public_path__ + "img/SH.c39480d5.svg";